const mainMixins = {
	data() {
		return {

		}
	},
	methods: {
		async getUserApi() {
			if(!user) {
				if(headers) {
					if(localStorage.userETC) {
						await axios.post(apiKS + 'api/userdecrypt', {usuario: localStorage.userETC}, { headers })
						.then( response => {
							user = JSON.parse(response.data.user)
						}).catch( error => {
							this.catchError(error)
						})
					}else{
						router.replace('/login')
					}
				}else{
					router.replace('/login')
				}
			}
		},
		async getPaises() {
            await axios.get(apiKS + 'api/paises', { headers: clientAPI })
            .then( ({ data }) => (this.paises = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getIdiomas() {
            await axios.get(apiKS + 'api/idiomas', { headers: clientAPI })
            .then( ({ data }) => (this.idiomas = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getEstados(value) {
            await axios.get(apiKS + 'api/estados?id_pais=' + value, { headers: clientAPI })
            .then( ({ data }) => (this.estados = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getCiudades(value) {
            await axios.get(apiKS + 'api/ciudades?id_estado=' + value, { headers: clientAPI })
            .then( ({ data }) => (this.ciudades = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },
        async getZonasHorarias() {
            await axios.get(apiKS + 'api/zonashorarias', { headers: clientAPI })
            .then( ({ data }) => (this.zonashorarias = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async saveDataNoForm(url, model, urlReturn, emitEvent, closemodal, clearmodel, tipoMensaje, modelOriginal) {
			this.openLoading()
			await axios.post(apiKS + url, model, { headers })
            .then( response => {
                Swal.close()
                if (response.data.status == true) {
                    if(tipoMensaje == 1 || tipoMensaje == undefined || tipoMensaje == null || tipoMensaje == 3) {
                        Swal.fire({
                            title: "Exito",
                            text: response.data.message,
                            icon: "success",
                            onClose: () => {
                                if(urlReturn != '' && tipoMensaje == 1)
                                    router.push(urlReturn)
                               	if(urlReturn != '' && tipoMensaje == 3)
                                    location.reload()
                            }
                        })
                    }else{
                        var $toast = toastr['success'](response.data.message, 'Exito')
                    }

                    if(emitEvent != '') {
                        Fire.$emit(emitEvent)
                    }
                    if(closemodal) {
                        this.closeModal(closemodal)
                    }
                    if(clearmodel == 1) {
                        this.clearModel()
                    }
                    if(clearmodel == 2) {
                        this.clearModelPartidas(modelOriginal)
                    }
                }
                if (response.data.status == false) {
                	Swal.fire({
			        	icon: 'error',
			        	title: 'Oops...',
			        	text: response.data.message,
			        })
                }
            })
            .catch( error => {
                this.catchError(error)
            })
		},

		async register(url, model, urlReturn, emitEvent, closemodal, clearmodel, tipoMensaje, modelOriginal) {
            this.openLoading()
			grecaptcha.execute('6Ldv78EZAAAAAFapAMeP1FaE4JYQDaZhsTskA119')
            .then((token) => {
			    this.model.captchaToken = token
                console.log("captchaToken: " + this.model.captchaToken);




                 axios.post(apiKS + url, model, { headers: clientAPI })
                .then( response => {
                    Swal.close()
                    if (response.data.status == true) {
                        if(tipoMensaje == 1 || tipoMensaje == undefined || tipoMensaje == null || tipoMensaje == 3) {
                            Swal.fire({
                                title: "Exito",
                                text: response.data.message,
                                icon: "success",
                                onClose: () => {
                                    if(urlReturn != '' && tipoMensaje == 1)
                                        router.push(urlReturn)
                                    if(urlReturn != '' && tipoMensaje == 3)
                                        location.reload()
                                }
                            })
                        }else{
                            var $toast = toastr['success'](response.data.message, 'Exito')
                        }

                        if(emitEvent != '') {
                            Fire.$emit(emitEvent)
                        }
                        if(closemodal) {
                            this.closeModal(closemodal)
                        }
                        if(clearmodel == 1) {
                            this.clearModel()
                        }
                        if(clearmodel == 2) {
                            this.clearModelPartidas(modelOriginal)
                        }
                    }
                    if (response.data.status == false) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: response.data.message,
                        })
                    }
                })
                .catch( error => {
                    this.catchError(error)
                })
            });
		},

		openLoading() {
			Swal.fire({
	            title: 'Espere por favor...',
	            allowEscapeKey: false,
	            allowOutsideClick: false,
	            showConfirmButton: false,
	            onOpen: () => {
	                Swal.showLoading()
	            }
	        })
		},

		catchError(error) {
			Swal.close()
	        if(error.response.status == 401)
	            router.replace('/login')
	        if(error.response.status == 500 || error.response.status == 404 || error.response.status == 405){
	            Swal.fire({
		        	icon: 'error',
		        	title: 'Oops...',
		        	text: error.response.statusText + ' ' + error.response.data.message,
		        })
	        }
		},

		async getProductos() {
            await axios.get(apiKS + 'api/productos?aparece_index=1', { headers: clientAPI })
            .then( ({ data }) => (this.productos = data.data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async getProductosUsuario(id_usuario) {
            await axios.get(apiKS + 'api/productosusuario?id_usuario=' + id_usuario, { headers: clientAPI })
            .then( ({ data }) => (this.productosusuario = data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async getCodigosUsuario() {
            await axios.get(apiKS + 'api/codigos-usuario', { headers })
            .then( ({ data }) => (this.codigosUsuario = data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async getCourseLessons(platform, product) {
            await axios.get(apiKS + `api/lecciones-curso?platform=${platform}&product=${product}`, { headers })
            .then( ({ data }) => (this.courseLessons = data))
            .catch( error => {
                this.catchError(error)
            })
        },

        async getClients() {
            await axios.get(apiKS + 'api/clientes?activo=1&aparece_ethinking_pro=1', { headers: clientAPI })
            .then( (response) => {
                this.clients = response.data.data
                this.clients.push({id: 0, nombre: 'Sin escuela o institución'})
            })
            .catch( error => {
                this.catchError(error)
            })
        },

        showMessage(title, message, icon) {
            Swal.fire({
                title: title,
                text: message,
                icon: icon,
            })
        }
	}
}

export default mainMixins